"use client";
import { createTheme, responsiveFontSizes } from "@mui/material";
import { faIR } from "@mui/material/locale";
import { blueGrey } from "@mui/material/colors";
import { outlinedInputClasses } from "@mui/material/OutlinedInput";
export let theme = createTheme(
  {
    components: {
      MuiTextField: {
        styleOverrides: {
          root: {
            "--TextField-brandBorderColor": "#E0E3E7",
            "--TextField-brandBorderHoverColor": "#B2BAC2",
            "--TextField-brandBorderFocusedColor": "#E7A66B",
            "& label.Mui-focused": {
              color: "var(--TextField-brandBorderFocusedColor)",
            },
          },
        },
      },
      MuiOutlinedInput: {
        styleOverrides: {
          notchedOutline: {
            borderColor: "var(--TextField-brandBorderColor)",
            borderRadius: 12,
          },
          root: {
            [`&.MuiInputBase-root`]: {
            borderRadius: 12,
            background: "#fff",
            },
            [`&:hover .${outlinedInputClasses.notchedOutline}`]: {},
            [`&.Mui-focused .${outlinedInputClasses.notchedOutline}`]: {
              borderColor: "var(--TextField-brandBorderFocusedColor)",
              boxShadow: "0px 0px 0px 4px #E7A66B30",
            },
          },
        },
      },
    },
    direction: "rtl",

    typography: {
      fontSize: 14,
      fontFamily: ["Yekan Bakh FaNum"].join(","),
      h1: {
        // fontSize: 96,
        fontWeight: 700,
      },
      h2: {
        // fontSize: 60,
        fontWeight: 700,
      },
      h3: {
        // fontSize: 48,
        fontWeight: 700,
      },
      h4: {
        // fontSize: 34,
        fontWeight: 700,
      },
      h5: {
        // fontSize: 24,
        fontWeight: 700,
      },
      h6: {
        // fontSize: 20,
        fontWeight: 600,
      },
      body1: {
        fontSize: 16,
        fontWeight: 400,
      },
      body2: {
        fontWeight: 400,
        fontSize: 14,
      },
      subtitle1: {
        fontWeight: 600,
        fontSize: 16,
      },
      subtitle2: {
        fontWeight: 600,
        fontSize: 14,
      },
      button: {
        fontSize: 14,
      },
      caption: {
        fontSize: 12,
      },
      overline: {
        fontSize: 12,
      },
    },
    palette: {
      primary: {
        main: "#212121",
        contrastText: "#ffffff",
        light: "#e6f3ff",
        "100": "#80C4FF",
      },
      grey: {
        "900": "#212121",
        "800": "#353535",
        "700": "#505050",
        "600": "#717171",
        "500": "#909090",
        "400": "#ADADAD",
        "300": "#CBDBDB",
        "200": "#D9D9D9",
        "100": "#E1E1E1",
        "50": "#EDEDED",
      },
      secondary: {
        main: "#E7A66B",
        "50": "#FFF7F0",
        "100": "#FFF3E8",
        "200": "#FFEFE1",
        "300": "#FFE7D1",
        "400": "#FFDFC2",
        "500": "#F3BE8F",
        "600": "#E7A66B",
        "700": "#DA8D48",
        "800": "#D48136",
        "900": "#CE7524",
        contrastText: "#fafafa",
      },
      error: {
        main: "#C30000",
        "100": "#ED2E2E",
        light: "#FFF2F2",
      },
      warning: {
        main: "#A9791C",
        "100": "#F4B740",
        light: "#FFF8E1",
      },
      success: {
        main: "#00966D",
        "100": "#00BA88",
        light: "#F3FDFA",
      },
      info: {
        main: "#2F80ED",
        "100": "#64A0F2",
        "50": "#E3F2FD",
        light: "#BDD7F9",
      },

      text: {
        primary: blueGrey[800],
      },
      white: {
        default: "#fafafa",
        main: "#fafafa",
        contrastText: "#353535",
      },
      background: {
        default: "#FFFCFA",
        paper: "#fff",
      },
    },
  },
  faIR,
);

theme.typography.body1 = {
  ...theme.typography.body1,
  [theme.breakpoints.down("md")]: {
    fontSize: "0.85rem",
  },
};
theme.typography.body2 = {
  ...theme.typography.body2,
  [theme.breakpoints.down("md")]: {
    fontSize: "0.85rem",
  },
};
theme.typography.subtitle1 = {
  ...theme.typography.subtitle1,
  [theme.breakpoints.down("md")]: {
    fontSize: "0.85rem",
  },
};
theme.typography.subtitle2 = {
  ...theme.typography.subtitle2,
  [theme.breakpoints.down("md")]: {
    fontSize: "0.85rem",
  },
};
theme.typography.button = {
  ...theme.typography.button,
  [theme.breakpoints.down("md")]: {
    fontSize: "0.9rem",
  },
  [theme.breakpoints.down("sm")]: {
    fontSize: "0.85rem",
  },
};
theme = responsiveFontSizes(theme, { factor: 3, disableAlign: true });
